import { Skeleton } from '@/shared/components/ui/skeleton';
import { Separator } from '@/shared/components/ui/separator';

export function ProjectInfoSkeleton() {
  return (
    <div className="space-y-8" data-testid="settings-project-info-skeleton">
      {/* Section 1 — project data */}
      <div>
        <div className="pb-6 space-y-1.5">
          <Skeleton className="h-6 w-28" />
          <Skeleton className="h-4 w-64" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-[140px_1fr] gap-8 items-start">
          <div className="flex justify-center">
            <Skeleton className="size-[60px] md:size-[100px] rounded-xl" />
          </div>
          <div className="space-y-6">
            <div className="space-y-3">
              <Skeleton className="h-4 w-12" />
              <Skeleton className="size-8 rounded-full" />
            </div>
            <Skeleton className="h-9 w-full" />
            <Skeleton className="h-20 w-full" />
            <div className="grid grid-cols-2 gap-4">
              <Skeleton className="h-9 w-full" />
              <Skeleton className="h-9 w-full" />
            </div>
          </div>
        </div>
        <div className="flex justify-end mt-10">
          <Skeleton className="h-9 w-28" />
        </div>
      </div>

      <Separator />

      {/* Section 2 — status */}
      <div>
        <div className="pb-6 space-y-1.5">
          <Skeleton className="h-6 w-24" />
          <Skeleton className="h-4 w-48" />
        </div>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-16" />
            <Skeleton className="h-5 w-16 rounded-full" />
          </div>
          <div className="flex items-center justify-between">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-5 w-12 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
}
